import React from 'react';
import {getDurationJsx} from "../../service/getDuration";

export function GetTime ({ev}){
    return ev ? <div className='game-entrance'>
        <p>Вход в игру в: {ev.startTime}</p>
        <p>Время в игре:  {getDurationJsx(ev.startTime,ev.endTime)}</p>
        <p>Выход из игры в: {ev.endTime}</p>
    </div> : null
}